type FiltersIconProps = {
  color?: string;
};

const FiltersIcon: React.FC<FiltersIconProps> = ({ color = "#000" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 7.49912C3 7.3002 3.07902 7.10944 3.21967 6.96879C3.36032 6.82813 3.55109 6.74912 3.75 6.74912H7.23469C7.39635 6.20759 7.72845 5.7327 8.18163 5.39504C8.63481 5.05739 9.18486 4.875 9.75 4.875C10.3151 4.875 10.8652 5.05739 11.3184 5.39504C11.7715 5.7327 12.1037 6.20759 12.2653 6.74912H20.25C20.4489 6.74912 20.6397 6.82813 20.7803 6.96879C20.921 7.10944 21 7.3002 21 7.49912C21 7.69803 20.921 7.88879 20.7803 8.02945C20.6397 8.1701 20.4489 8.24912 20.25 8.24912H12.2653C12.1037 8.79064 11.7715 9.26553 11.3184 9.60319C10.8652 9.94084 10.3151 10.1232 9.75 10.1232C9.18486 10.1232 8.63481 9.94084 8.18163 9.60319C7.72845 9.26553 7.39635 8.79064 7.23469 8.24912H3.75C3.55109 8.24912 3.36032 8.1701 3.21967 8.02945C3.07902 7.88879 3 7.69803 3 7.49912ZM20.25 15.7491H18.2653C18.1037 15.2076 17.7715 14.7327 17.3184 14.395C16.8652 14.0574 16.3151 13.875 15.75 13.875C15.1849 13.875 14.6348 14.0574 14.1816 14.395C13.7285 14.7327 13.3963 15.2076 13.2347 15.7491H3.75C3.55109 15.7491 3.36032 15.8281 3.21967 15.9688C3.07902 16.1094 3 16.3002 3 16.4991C3 16.698 3.07902 16.8888 3.21967 17.0294C3.36032 17.1701 3.55109 17.2491 3.75 17.2491H13.2347C13.3963 17.7906 13.7285 18.2655 14.1816 18.6032C14.6348 18.9408 15.1849 19.1232 15.75 19.1232C16.3151 19.1232 16.8652 18.9408 17.3184 18.6032C17.7715 18.2655 18.1037 17.7906 18.2653 17.2491H20.25C20.4489 17.2491 20.6397 17.1701 20.7803 17.0294C20.921 16.8888 21 16.698 21 16.4991C21 16.3002 20.921 16.1094 20.7803 15.9688C20.6397 15.8281 20.4489 15.7491 20.25 15.7491Z"
        fill={color}
      />
    </svg>
  );
};

export default FiltersIcon;
